<template>
  <div class="upload uploadImg" :is_require="this.UpFile.is_require" :name="this.UpFile.name">
    <div class="load-bl">
      <h5 class="tit">
        {{this.UpFile.title}}
        <span v-show="this.UpFile.is_require == 1" style="color: #cf5454;margin-left: 5px;">*</span>
        <!--   <a class="uploadImgShow" href="javascript:void(0);" @click="fn">我已上传的<i class="icon-r"></i></a>-->
      </h5>
      <div class="uploa-bg">
        <div class="load-inner">
          <!--展示-->
          <div v-if="MyUploadImg.length > 0" class="load-link load-over videoFile2" style="margin-bottom: 15px;" v-for="(item,ind) in MyUploadImg">
            <div class="pic-b pic-v">
              <!--头像修改成功！需要审核后才能生效-->
              <img :src="item.file.image_url +'?p=3&o=2&w=1000&h=500'" alt="" @click="needScan(ind, item.file.image_url)"/>
            </div>
            <p :attr-uuid="item.file_id" attr-type="2" class="fileName2" style="padding-left: 10px;max-height: 50px">{{item.file.title}}</p>
            <!-- <span>上传成功！</span>-->
          </div>
          <div class="load-link load-over videoFile2" style="margin-bottom: 15px;" v-for="(item,ind) in fileName2">
            <span class="pic-del" @click="updateFile(ind)">×</span>
            <div class="pic-b pic-v" @click="needScan(ind)">
              <!--头像修改成功！需要审核后才能生效-->
              <!--img :src="arrayImg[ind] +'?imageView2/2/w/100/h/100/ignore-error/1'" alt=""/-->
                <img src="/images/audit_2.jpg" alt=""/>
            </div>
            <p :attr-uuid="arrayUuid2[ind]" attr-type="2" class="fileName fileName2" style="padding-left: 10px;max-height: 50px">{{arrayName2[ind]}}</p>
            <!-- <span>上传成功！</span>-->
          </div>
          <div id="videoContainer2" class="load-link">
            <div class="pic-b" id="selectVideo2">
              <input type="file" accept="image/*" id="select2"/>
            </div>
          </div>
        </div>
        <p class="et-load-info et-img-info" :class="classObj" ref="p_info" @click="allTetx2" v-if="this.UpFile.tip">
          <span>[要求]</span>
          {{upfileTip}}
        </p>
        <p class="et-load-info et-img-info" @click="allTetx2" v-else>
          <span>[要求]</span>
          支持JPG、GIF、PNG格式，大小不超过100mb的图片
        </p>
      </div>
    </div>
    <!--上传弹窗-->
    <div class="upload-modal large-info-modal modal fade" id="uploadModal2" data-backdrop="static" role="dialog" aria-hidden="false" style="background: rgba(0,0,0,.4)">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="top: 0">
          <div class="modal-body">
            <div class="modal-inner">
              <div class="pl-form">
                <div class="group">
                  <label>名称<span>*</span></label>
                  <div class="pl-ipbox">
                    <input id="Textimg" v-model="textName" type="text" placeholder="请输入名称" maxlength="20" />
                  </div>
                </div>
                <div class="group">
                  <label>描述</label>
                  <div class="pl-ipbox">
                    <textarea id="Textareaimg"  rows="3" placeholder="请输入描述信息,100字以内" maxlength="100"></textarea>
                  </div>
                </div>
                <!--<a href="javascript:void(0);" class="btn-pl-start btn-pl-giveups" style="float: left; width: 40%;">取消</a>-->
                <a href="javascript:void(0);" class="btn-2 buttonW buttonR" @click="cancel2">取消</a>
                <a href="javascript:void(0);" class="btn-pl-start btn-pl-start2 buttonW buttonL">开始上传</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--上传弹窗-->
    <div class="upload-modal large-info-modal modal fade" id="uploadFile" data-backdrop="static" role="dialog" aria-hidden="false" style="background: rgba(0,0,0,.5);">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="top:0">
          <div class="modal-head">
            我的视频
            <span data-dismiss="modal">X</span>
          </div>
          <div class="modal-body" id="modal-body">
            <ul class="uploadFile-ul clearfix" id="uploadFile-ul">
              <li v-for="(item,v) in allchannel">
                <dl>
                  <dt class="pic-box"><img :src="item.image.thumb_url" alt="" style="border: none"/></dt>
                  <dd>{{item.image.title}}</dd>
                </dl>
              </li>
            </ul>
            <!-- load -->
            <div class="content index-content" style="padding-top: 0" v-if="scrill">
              <div class="id-content-inner">
                <div class="loader">
                  <div class="loader-inner ball-pulse" style="display: block">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--提示-->
    <div class="upload-modal large-info-modal modal fade" id="uploadImg-al" data-backdrop="static" role="dialog" aria-hidden="false" style="background: rgba(0,0,0,.4)">
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="top: 100px">
          <div class="modal-body">
            <p class="detailAlert-p Prompt-p">上传格式错误</p>
            <a href="javascript:void(0);" data-dismiss="modal" class="buttonZ">确定</a>
          </div>
        </div>
      </div>
    </div>
    <!-- 图片预览 -->
    <div class="scan-mask" v-show="scan.isScan" @click="closeScan">
      <div class="scan-box">
        <img :src="scan.url"><span></span>
      </div>
    </div>
  </div>
</template>
<script>
    export default {
        props: [
            'UpFile',
            'type',
            'id',
            'countArr',
            'appId',
            'audit_level'
        ],
        data() {
            return {
                uptoken2: '',
                fileId2: '',
                fileName2: 0,
                arrayName2: [],
                arrayUuid2: [],
                arrayImg: [],
                textTares: '',
                textName: '',
                allchannel: [],
                scrill: true,
                page: 1,
                key: '',
                allTyle2: false,
                numberSize2: 0,
                Uploaded2: 0,
                MyUploadImg: [],
                typeNmae2: '',
                scan: {
                    isScan: false,
                    url: '',
                },
                pngSds:   API.GlobalUrl+'static/dist/img/audit_2.jpg',
                reject_img:   API.GlobalUrl+'static/dist/img/reject_2.jpg',
                upload_success_img: '/images/upload_success_2.jpg',
                originArr: {
                    "paike-hb" : 'http://paike-hb.ishow.cctv.com',
                    "paike-hd" : 'http://paike-hd.ishow.cctv.com',
                    "paike-sea" : 'http://paike-sea.ishow.cctv.com'
                },
                moreInfo: false,
                classObj: {
                    active: false,
                    'down-arrow':false,
                    all: false,
                    elips: false,
                },
                upfileTip:'',
            }
        },
        methods: {
            //操作按钮事件
            allTetx2() {
                if(!this.moreInfo) return;
                this.allTyle2 = !this.allTyle2
                if (this.allTyle2) {
                    // $('.et-video-info').css('white-space','normal');
                    this.classObj = {
                        active: true,
                        'down-arrow':true,
                        all: true,
                        // elips: false,
                    }
                    this.upfileTip = this.UpFile.tip;

                }else{
                    // $('.et-video-info').css('white-space','nowrap');
                    this.classObj = {
                        active: false,
                        'down-arrow':true,
                        all: false,
                        // elips: true,
                    }
                    this.upfileTip = this.UpFile.tip.substr(0,50) + '...';
                }
            },
            fn() {
                var that = this
                $('#uploadFile').modal('show');
                this.$http.get(API.GetUploadFileForMe, { params: { file_type: '2', page: '1', pagesize: '10', status: 'pass' } })
                    .then(function(res) {
                        if (res.code == '0') {
                            for (var i = 0; i < res.data.length; i++) {
                                that.allchannel.push(res.data[i]);
                            }
                            that.$nextTick(function() {
                                setTimeout(function() {
                                    var picWimg = $('.pic-box').width();
                                    var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
                                    $('.pic-box').css('height', picHimg)
                                    $('.pic-box img').css({ width: picWimg, height: picHimg, visibility: 'visible' });
                                }, 200)

                            })
                        }
                    });
            },
            // Uptoken2() {
            //     var that = this
            //     var id = that.$route.params.id || that.id;
            //     this.$http.get(API.ImageToken, { params: { activity_id: id, app_id: that.appId } })
            //         .then(function(res) {
            //             console.log(res)
            //             if (res.code == 1) {
            //                 that.fileId2 = '';
            //                 that.uptoken2 = ''
            //             } else {
            //                 that.key = res.data.fileId;
            //                 that.fileId2 = res.data.fileId;
            //                 that.uptoken2 = res.data.uptoken
            //             }
            //         })
            // },
            cancel2() {
                $('#uploadModal2').modal('hide');
                $('#Textimg').val('');
                $('#Textareaimg').val('');
                $('#select2').val('');
            },
            updateFile(idx) {
                this.fileName2--;
                this.arrayImg.splice(idx, 1);
                this.arrayName2.splice(idx, 1);
                this.arrayUuid2.splice(idx, 1);

                if (this.numberSize2 > this.fileName2 + this.MyUploadImg) {
                    $('#videoContainer2').show();
                }
            },
            delFile(idx){
                this.MyUploadImg.splice(idx,1);
                if (this.numberSize2 > this.fileName2 + this.MyUploadImg) {
                    $('#videoContainer2').show();
                }
            },

            needScan(idx,url){
                if(url){
                    this.scan.url =  url + '?p=3&o=2&w=500&h=500';
                }else{
                    this.scan.url = this.arrayImg[idx] + '?imageView2/2/w/500/h/500/ignore-error/1';
                }
                this.scan.isScan = true;
                $('body').addClass('modal-open');
            },
            closeScan(){
                this.scan.isScan = false;
                $('body').removeClass('modal-open');
            },
            initMoreInfo(){
                var pinfo = this.$refs.p_info;
                if(pinfo){
                    var offH = pinfo.offsetHeight;
                    var scrollH = pinfo.scrollHeight;
                    // console.log(pinfo,offH,scrollH);
                    if(scrollH > offH){
                        this.moreInfo = true;
                        this.classObj = {
                            active: false,
                            all:false,
                            // elips:true,
                            'down-arrow':true,
                        }
                        this.upfileTip = this.UpFile.tip.substr(0,50) + '...';
                    }
                }
            },

        },
        created: function() {
            this.upfileTip = this.UpFile.tip;

        },
        mounted: function() {
            //操作DOM

            var that = this,
                subscription2;
            var id = this.$route.params.id;
            that.typeNmae2 = that.UpFile.field_type;
            this.initMoreInfo();
            //if (this.UpFile.field_type == 'uploadimg') {
            if (that.UpFile.choose_num == '0') {
                $('.uploadImg').hide();
                return false;
            }
            /*   this.$http.get(API.GetUploadFileForMe,{params: {file_type: '1',page: '1',pagesize: '10',status: 'pass'}})
                 .then(function (res) {
                   console.log(res)
                   if (res.code == '0') {
                     if(res.data.length == 0){
                       $('.uploadImgShow').hide()
                     }
                   }
                 });*/
            // console.log(that.UpFile.choose_num)
            if (that.type != 0) {
                that.ByUserid = {
                    file_type: 2,
                    activity_id: that.id
                };
                //  console.log(that.ByUserid)
                this.$http.get(API.GetActivityFileByUserid, { params: that.ByUserid })
                    .then(function(res) {
                        console.log(res)
                        if (res.code == 0) {
                            for (var i = 0; i < res.data.length; i++) {
                                that.MyUploadImg.push(res.data[i]);
                                // console.log(i)
                            }
                            that.arrayUuid2 = [];
                            that.arrayName2 = [];
                            that.fileName2 = 0;
                            if (!that.UpFile.choose_num) {
                                that.numberSize2 = 1
                            } else {
                                that.numberSize2 = that.UpFile.choose_num
                            }
                            if (that.numberSize2 == '' || that.numberSize2 == null || that.numberSize2 <= res.total) {
                                $('#videoContainer2').hide();
                            }
                        }
                    });

            } else {

                that.numberSize2 = that.UpFile.choose_num;
            }
            $('#select2').unbind().change(function() {
                if (id == '100071' || that.id == '100071') {
                    $('#Textimg').val('我的观后感')
                } else {
                    $('#Textimg').val('');
                }
                $('#Textareaimg').val('');

                var file = this.files[0]; //文件
                var key = file.name; //文件总名
                var name = key.split('.');
                var ext = name[name.length - 1].toLowerCase();
                if (ext != 'jpg' && ext != 'gif' && ext != 'png' && ext != 'jpeg') {
                    $('#uploadImg-al .detailAlert-p').html('上传格式错误');
                    $('#uploadImg-al').modal('show');
                    return false;
                }
                var fileSize = file.size / 1024 / 1024;
                if (fileSize > 20) {
                    $('#uploadImg-al .detailAlert-p').html('图片大小不能超过20MB');
                    $('#uploadImg-al').modal('show');
                    return false
                }


                var params = key.split('.')[0]; //文件名
                // var domain ='upload-cc';  //域名
                var putExtra = {
                    fname: key,
                    params: {},
                    mimeType: null
                };
                //文件配置
                var config = {
                    useCdnDomain: true,
                    disableStatisticsReport: false,
                    retryCount: 6
                    //region: ''  //上传区域
                };
                //进度
                var next = function(response) {
                    var file = response;
                    //console.log(file);
                    var size = file.size / 1024 / 1024;
                    var loaded = file.loaded / 1024 / 1024;
                    //总大小
                    $('.SizeBox').html(size.toFixed(2));
                    //已上传
                    $('.SecondBox').html(loaded.toFixed(2));
                    //上传进度
                    $('.pl-num').children('span').html(file.percent.toFixed(2));
                    //上传进度条
                    $('.pl-gro-bar').css('width', file.percent + '%');
                };
                //保错
                var error = function(err) {
                    console.log(err);
                    $('#uploadImg-al .detailAlert-p').html('上传出错');
                    $('#uploadImg-al').modal('show')
                    $('#select2').val('');
                };
                //上传成功
                var complete = function(isSuccess ,code , backData) {
                    if (isSuccess) {
                        ++that.fileName2;
                        var userData = JSON.parse(ALY.util.base64.decode(backData.userData)).Vod.UserData
                        // if (res.data.file_path) {
                        //   var bucket = res.data.bucket;
                        //   that.arrayImg.push(that.originArr[bucket] + '/'+ res.data.file_path)
                        // }
                        that.arrayName2.push($('#Textimg').val());
                        that.arrayUuid2.push(userData.file_id);
                        $('#processModal').modal('hide');
                        $('#Textimg').val('');
                        $('#Textareaimg').val('');
                        $('#select2').val('');
                        if (that.numberSize2 <= that.fileName2 + that.MyUploadImg.length) {
                            $('#videoContainer2').hide();
                        } else {
                            //that.Uptoken2();
                        }

                    } else {
                        $('#processModal').modal('hide');
                        $('#Textimg').val('');
                        $('#Textareaimg').val('');
                        $('#select2').val('');
                        $('#uploadImg-al .detailAlert-p').html(backData);
                        $('#uploadImg-al').modal('show')
                    }
                };

                // 上传全家福100131
                var activeId = that.id;
                console.log(activeId)
                if(activeId== '100131'){
                    var param = { }
                    param.title = '我与地球全家福';
                    param.description  = '我与地球全家福';//描述
                    if(that.$route.params.id == 0){
                        params.activity_id = that.id;
                    }else{
                        params.activity_id = that.$route.params.id || that.id;
                    }

                    params.source = "1";
                    params.app_id = that.appId;
                    params.audit_level = that.audit_level;
                    // console.log("imageupload" + params.audit_level);
                    var content = {
                        file: file,          //文件名 必填
                        file_type:"2",
                        Biography: params
                    };

                    $('#uploadModal2').modal('hide');
                    $('#processModal').modal('show');
                    $.fn.uploadHandle(content,function () {
                        console.log("开始上传！");
                    },next, complete);
                }else{
                    $('#uploadModal2').modal('show');
                }
                //上传
                $('.btn-pl-start2').unbind('click').on('click', function() {
                    if ($('#Textimg').val().trim() == '') {
                        $('#Textimg').focus()
                    } else {
                        var params = {}
                        params.title = $('#Textimg').val();
                        if($('#Textareaimg').val()){
                            params.description = $('#Textareaimg').val();
                        }else{
                            params.description = $('#Textimg').val();
                        }
                        if(that.$route.params.id == 0){
                            params.activity_id = that.id;
                        }else{
                            params.activity_id = that.$route.params.id || that.id;
                        }

                        params.source = "1";
                        // params.audit_level = '2';
                           params.audit_level = that.audit_level;
                        //  console.log("imageupload" + params.audit_level);
                        params.app_id = that.appId;
                        // console.log(params);
                        var content = {
                            file: file,          //文件名 必填
                            file_type:"2",
                            Biography: params
                        };
                        $('#uploadModal2').modal('hide');
                        $('#processModal').modal('show');
                        $.fn.uploadHandle(content,function () {
                            console.log("开始上传！");
                        },next, complete);
                    }
                });
                //取消
                $('.btn-pl-giveup').unbind('click').on('click', function() {
                    $.fn.stopUploadFile();
                    $.fn.cancleUploadFile();
                    $.fn.deleteUploadFile();
                    $('#Textimg').val('');
                    $('#Textareaimg').val('');
                    $('#select2').val('')
                });
            });

            var nScrollHight = 0; //滚动距离总长(注意不是滚动条的长度)
            var nScrollTop = 0; //滚动到的当前位置
            var len = 10;
            //滚动加载
            $('#modal-body').scroll(function() {
                nScrollHight = $(this)[0].scrollHeight;
                nScrollTop = $(this)[0].scrollTop; //能获取到
                var nDivHight = $('#modal-body').height();
                //console.log(nScrollHight,nScrollTop,nDivHight)
                //console.log(that.allchannel.length >= len)
                if (that.allchannel.length >= len) {
                    that.scrill = true;
                } else {
                    that.scrill = false;
                }
                if (nScrollTop + nDivHight + 40 >= nScrollHight && that.scrill) {
                    that.scrill = false;
                    //正在进行二次加载
                    var page = ++that.page;
                    len = len / 1 + 10;
                    $.getJSON(API.GetUploadFileForMe + '?jsoncallback=?&file_type=2&pagesize=10&page=' + page, function(res) {
                        if (res.code == '0') {
                            for (var i = 0; i < res.data.length; i++) {
                                that.allchannel.push(res.data[i]);
                            }
                            that.$nextTick(function() {
                                setTimeout(function() {
                                    var picWimg = $('.pic-box').width();
                                    var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
                                    $('.pic-box').css('height', picHimg)
                                    $('.pic-box img').css({ width: picWimg, height: picHimg, visibility: 'visible' });
                                }, 200)
                            })
                        } else {
                            console.log()
                        }
                    });

                }
            });

        }

    }

</script>
<style scoped>
  .scan-mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    /*display: none;*/
  }
  .scan-box{
    padding: 20px;
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    text-align: center;
    /*display: flex;*/
    /*justify-content: center;*/
    /*align-items: center;*/
  }
  .scan-box img{
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
    width: auto;
  }
  .scan-box span{
    height: 100%;
    width: 0;
    display: inline-block;
    vertical-align: middle;
  }

</style>



// WEBPACK FOOTER //
// src/components/UploadToken/imageUpload.vue